@if (order$ | async; as sikoOrder) {
   <div class="container">
      <app-order-confirmation-thank-message
         [order]="sikoOrder"
         [sikoUser$]="sikoUser$"
         [pgStatus]="paymentGatewayPaymentStatus"
      ></app-order-confirmation-thank-message>
      @if (hasGiveawayCoupons) {
         <div class="giveaway-coupons">
            <h3 class="coupon-title text-center">{{
               'sikoMyCoupons.couponGiveAway' | cxTranslate
            }}</h3>
            @if (sikoUser$ | async; as user) {
               <div class="pb-2 text-center siko-lh-150">
                  {{ 'sikoMyCoupons.couponGiveAwayDescription' | cxTranslate }}
               </div>
            }
            @for (promotions of sikoOrder.appliedOrderPromotions; track promotions) {
               @for (coupon of promotions.giveAwayCouponCodes; track coupon) {
                  <app-coupon-card
                     [coupon]="coupon"
                     [giveAwayCoupon]="true"
                     class="d-flex justify-content-center pb-32 wider"
                  ></app-coupon-card>
               }
            }
         </div>
      }
      <div class="row my-1 mb-5">
         <div class="col-12">
            <app-order-confirmation-overview></app-order-confirmation-overview>
         </div>
      </div>
      <app-order-details-items [sikoOrder$]="order$"></app-order-details-items>
      <div class="mt-5 mb-5">
         <app-order-detail-totals [order]="sikoOrder" [orderConfirmation]="true">
         </app-order-detail-totals>
      </div>
   </div>
} @else {
   <div class="cx-spinner">
      <cx-spinner></cx-spinner>
   </div>
}
